export default class HubEvent {
    constructor(type) {
        this.type = type;
    }
}

HubEvent.SHOW_REQUEST = "HubEvent.SHOW_REQUEST";
HubEvent.HIDE_REQUEST = "HubEvent.HIDE_REQUEST";
HubEvent.REFRESH_KEY_DECISIONS_LIST = "HubEvent.REFRESH_KEY_DECISIONS_LIST";
HubEvent.UNSELECT_KEY_DECISION_LIST_ITEM = "HubEvent.UNSELECT_KEY_DECISION_LIST_ITEM";